export default "__VITE_ASSET__DRN_g4Eq__"